import React from "react";
import styled from "styled-components";
import { HelpText } from "../Styles";

const FieldWrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1 1 calc(25% - 20px); /* Four fields in a row */
  min-width: calc(25% - 20px);
  margin-bottom: 20px;

  @media (max-width: 900px) {
    flex: 1 1 calc(50% - 20px); /* Two fields in a row */
    min-width: calc(50% - 20px);
  }

  @media (max-width: 600px) {
    flex: 1 1 100%; /* One field in a row */
    min-width: 100%;
  }
`;

const Label = styled.label`
  font-weight: bold;
  font-size: 14px;
`;

const DisplayText = styled.span`
  padding: 10px;
  margin-top: 5px;
  border-radius: 4px;
  background-color: ${({ theme }) => theme.colors.background};
  width: 100%;
`;

function DisplayField({ label, text, helpText = "" }) {
  return (
    <FieldWrapper>
      <Label>{label}</Label>
      <DisplayText>{text}</DisplayText>
      {helpText && <HelpText>{helpText}</HelpText>}
    </FieldWrapper>
  );
}

export default DisplayField;
